import logo from './logo.svg';
import './App.css';
import HomePlanForm from "./HomePlanForm";
import Footer from "./Footer";
import ErrorBoundary from "./ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <div>
        <h1 style={{ textAlign: "center", marginTop: "2rem", fontWeight: 700, letterSpacing: 1 }}>
          
        </h1>
        <HomePlanForm />
        <Footer />
      </div>
    </ErrorBoundary>
  );
}

export default App;
//   return (
//     <ErrorBoundary>
//       <ThemeProvider theme={theme}>
//         <CssBaseline />
//         <div>
//           <h1 style={{ textAlign: "center", marginTop: "2rem", fontWeight: 700, letterSpacing: 1 }}>
//             Customized Home Plan
//           </h1>
//           <HomePlanForm />
//           <Footer />
//         </div>
//       </ThemeProvider>
//     </ErrorBoundary>
//   );
// }

// export default App;
